export const FETCH_LOAD_PROJECT_BY_COMPANY_ID_REQUEST = 'FETCH_LOAD_PROJECT_BY_COMPANY_ID_REQUEST'
export const FETCH_LOAD_PROJECT_BY_COMPANY_ID_SUCCESS = 'FETCH_LOAD_PROJECT_BY_COMPANY_ID_SUCCESS'
export const FETCH_LOAD_PROJECT_BY_COMPANY_ID_FALUIRE = 'FETCH_LOAD_PROJECT_BY_COMPANY_ID_FALUIRE'
export const FETCH_SEARCH_PROJECT='FETCH_SEARCH_PROJECT'
